import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { t } from "@/lib/i18n";
import { extractError } from "@/lib/api";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Register() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(username, email, password);
      toast.success("اکاؤنٹ بن گیا — خوش آمدید");
      nav("/");
    } catch (err) {
      toast.error(extractError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto py-10" data-testid="register-page">
      <Card className="p-6 sm:p-8 space-y-5">
        <div className="text-center space-y-1">
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-3 py-1 rounded-full text-xs font-eng"><Sparkles size={12} /> PakNet</div>
          <h1 className="urdu-naskh text-3xl font-semibold text-primary">{t.register}</h1>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="urdu-naskh" htmlFor="uname">{t.username}</Label>
            <Input id="uname" required minLength={3} maxLength={24} value={username} onChange={(e) => setUsername(e.target.value)} dir="ltr" data-testid="register-username" />
          </div>
          <div className="space-y-1.5">
            <Label className="urdu-naskh" htmlFor="email">{t.email}</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} dir="ltr" data-testid="register-email" />
          </div>
          <div className="space-y-1.5">
            <Label className="urdu-naskh" htmlFor="pw">{t.password}</Label>
            <Input id="pw" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} dir="ltr" data-testid="register-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-primary" data-testid="register-submit">
            {loading ? t.loading : t.register}
          </Button>
        </form>
        <div className="text-center text-sm urdu-naskh">
          پہلے سے اکاؤنٹ ہے؟ <Link to="/login" className="text-primary underline">{t.login}</Link>
        </div>
      </Card>
    </div>
  );
}
